import { City } from './index';

export class County {
  id: number;
  name: string;
  cities: City[] = [];
}
